// Palo Alto Cortex XDR (XQL) datasource mappings.
// Uses repo (dataset name), events (event_type ENUMs), and eventCodes (event_sub_type ENUMs).
// The emitter produces: dataset = {repo}\n| filter event_type = {events[0]} [and event_sub_type = {eventCodes[0]}]
import type { DatasourceMap } from '../datasource.types'

export const cortexXdrMap: DatasourceMap = {
  'Palo Alto Cortex XDR': {
    any: {
      process_creation: {
        repo: 'xdr_data',
        events: ['ENUM.PROCESS'],
        eventCodes: ['ENUM.PROCESS_START'],
      },
      file_event: {
        repo: 'xdr_data',
        events: ['ENUM.FILE'],
      },
      network_connection: {
        repo: 'xdr_data',
        events: ['ENUM.NETWORK'],
        unsupportedFields: ['url','domain'],
      },
      registry_event: {
        repo: 'xdr_data',
        events: ['ENUM.REGISTRY'],
      },
      image_load: {
        repo: 'xdr_data',
        events: ['ENUM.LOAD_IMAGE'],
      },
      // Cloud audit events — xdr_cloud_audit dataset; no event_type filter needed
      cloud: { repo: 'xdr_cloud_audit' },
      // DNS visible in network events (no separate DNS dataset in standard XQL)
      dns: { repo: 'xdr_data', events: ['ENUM.NETWORK','ENUM.STORY'], unsupportedFields: ['dns_answer'] },
      // Unsupported categories as defined in allowable types in zod/Hunter
      // System events (Windows service creation etc.) mapped via Windows EventCodes in xdr_data
      //system: { repo: 'xdr_data', eventCodes: ['7045', '7036'] },
      // Security events (scheduled tasks etc.) mapped via Windows EventCodes
      //security: { repo: 'xdr_data', eventCodes: ['4698', '4702'] },
      //authentication_events: {},
      //pipe_created
      //webserver:{},
      //proxy:{},
      //Rdp_event:{},  // No distinct RDP event_simpleName; covered by authentication_events
      //firewall:{},
      //application:{},
    },
  },
}